angular.module('rjmNg.directives').directive "filterList", [
  "$timeout"
  ($timeout) ->
    restrict: "E"
    templateUrl: "directive.filterList.html"
    replace: true
    scope:
      listItems: "="
      selected: "="
      stickyItems: "="
      filterAttribute: "@"
      filterValue: "="
    link: (scope, elem, attrs) ->
      scope.select = (item) ->
        scope.selected = item
      scope.getFocus = ($event) ->
        # hack to ensure the input with this function
        # on ng-click gets and keeps focus. have to
        # do this bc of a bootstrap modal bug
        $timeout ->
          $($event.currentTarget).focus()
        , 200
]
